
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class ListAppPurInvoiceDialog extends Serenity.EntityDialog<ListAppPurInvoiceRow, any> {
        protected getFormKey() { return ListAppPurInvoiceForm.formKey; }
        protected getIdProperty() { return ListAppPurInvoiceRow.idProperty; }
        protected getLocalTextPrefix() { return ListAppPurInvoiceRow.localTextPrefix; }
        protected getNameProperty() { return ListAppPurInvoiceRow.nameProperty; }
        protected getService() { return ListAppPurInvoiceService.baseUrl; }
        protected getDeletePermission() { return ListAppPurInvoiceRow.deletePermission; }
        protected getInsertPermission() { return ListAppPurInvoiceRow.insertPermission; }
        protected getUpdatePermission() { return ListAppPurInvoiceRow.updatePermission; }

        protected form = new ListAppPurInvoiceForm(this.idPrefix);

    }
}